const isDisableChangePersonalData = ({
  byIntegration,
  externalReferences,
  canChangePassword,
  listAppIdBlockedToChangePersonalData,
}) => {
  let blockedToChangePersonalData = false

  if (externalReferences) {
    blockedToChangePersonalData = externalReferences.some(({ applicationId }) =>
      listAppIdBlockedToChangePersonalData?.includes(applicationId),
    )
  }

  if (blockedToChangePersonalData) {
    return true
  }

  if (canChangePassword) {
    return byIntegration && !canChangePassword
  }

  return byIntegration
}

export default isDisableChangePersonalData
